import { render, staticRenderFns } from "./InvoicesList.vue?vue&type=template&id=b39993ba&"
import script from "./InvoicesList.vue?vue&type=script&lang=js&"
export * from "./InvoicesList.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports